import './set_refuse_reason.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import { requester_change_order_state } from '../../../../../../services/for_allServices';
import { service_change_off_catalogue_state_request } from '../../../../../../services/purchase_service';


function Set_refuse_reason({ open_reason_modal, details, setDetails, setOpen_reason_modal, products_bysupplier, setProducts_bysupplier, order_key, setorder_key }) {


  const [errorText, setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [reason, setReason] = useState('');


  function submit_refuse_reason() {
    setErrorText("");
    if (reason === '') {
      setErrorText("Champ vide !");
    } else {
      swal({
        title: "Etes-vous sûr ?",
        text: "!!!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            setWaiting(true);
            open_reason_modal.append('refuse_reason', reason);
            if (open_reason_modal.get('request_state')) {
              service_change_off_catalogue_state_request(open_reason_modal).then((response) => {
                console.log("change request state : ", response.data);
                setWaiting(false);
                setReason('');
                setOpen_reason_modal(null);
                let tmp = { ...details };
                tmp.request_state = response.data.request_state;
                tmp.requester_refuse_reason = response.data.requester_refuse_reason;
                setDetails(tmp);
                swal("Votre réponse a été enregistrée avec succès !", {
                  icon: "success",
                });
              }).catch((error => {
                console.log("change request state err : ", error.response);
                setWaiting(false);
              }))
            } else {
              if (open_reason_modal.get('state') === "non conforme") {
                requester_change_order_state(open_reason_modal).then((response) => {
                  let tmp_products = { ...products_bysupplier };
                  tmp_products[order_key].order_state = "non conforme";
                  setProducts_bysupplier(tmp_products);
                  setWaiting(false);
                  swal("votre réponse a été enregistrée avec succès et le fournisseur sera bientôt notifié !", {
                    icon: "success",
                  });
                  setOpen_reason_modal(null);
                }).catch((error) => {
                  //console.log(error.response);
                  setWaiting(false);
                })
              }
            }
          }
        });
    }
  }



  return (
    <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_reason_modal != null ? true : false} onClose={() => setOpen_reason_modal(null)} aria-labelledby="form-dialog-title" >
      <DialogTitle id="form-dialog-title">Motif du rejet</DialogTitle>
      <DialogContent>
        <div>
          {
            errorText == ""
              ? <></>
              : <p className={errorText ? "error" : "valid-champ"}>
                {errorText}
              </p>
          }

          <div style={{ width: "100%", marginTop: "5px" }} >
            <TextField
              id="outlined-multiline-flexible"
              label="Motif"
              variant='outlined'
              multiline
              minRows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>
        </div>


        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={waiting}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

      </DialogContent>
      <DialogActions>
        <div className='dialogBottom'>
          <div>
            {
              errorText === ""
                ? <></>
                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                  {errorText}
                </p>
            }
          </div>
          <div>
            <Button variant="contained" className={waiting ? "submit_but cancel_but disabled_button" : "submit_but cancel_but"} startIcon={<CancelIcon className="my_icon" />} onClick={() => setOpen_reason_modal(null)} >
              Annuler
            </Button>
            <Button variant="contained" className={waiting ? "submit_but valide_but disabled_button" : "submit_but valide_but"} startIcon={<SendIcon className="my_icon" />} onClick={submit_refuse_reason} >
              Envoyer
            </Button>
          </div>
        </div>
      </DialogActions>

    </Dialog>
  )
}

export default Set_refuse_reason
